module.exports = __webpack_public_path__ + "static/media/Sec-5_2677_CM.c79ca344.png";